<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
<div class="anf-auswahl__overlay" (click)="close()">
  <div
    #dialog
    class="anf-auswahl"
    data-testid="tf-anf-auswahl"
    role="dialog"
    aria-modal="true"
    aria-labelledby="anf-auswahl-titel"
    tabindex="-1"
    cdkTrapFocus
    (click)="$event.stopPropagation()"
    (keydown.escape)="onEscape($event)"
  >
    <div class="anf-auswahl__kopf">
      <app-icon class="anf-auswahl__kopf-icon" name="requirement" [size]="18" />
      <div class="anf-auswahl__kopf-text">
        <h2 id="anf-auswahl-titel" class="anf-auswahl__titel-kopf">
          {{ 'testCases.form.links.picker.title' | translate }}
        </h2>
        <p class="anf-auswahl__untertitel">{{ 'testCases.form.links.picker.subtitle' | translate }}</p>
      </div>
      <button
        type="button"
        class="anf-auswahl__schliessen"
        [attr.aria-label]="'testCases.form.links.picker.close' | translate"
        (click)="close()"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>

    <div class="anf-auswahl__filter">
      <div class="anf-auswahl__suche">
        <mat-icon class="anf-auswahl__lupe" aria-hidden="true">search</mat-icon>
        <input
          #suchfeld
          class="anf-auswahl__suche-feld"
          data-testid="tf-anf-auswahl-suche"
          type="search"
          [value]="query()"
          [disabled]="loading()"
          [placeholder]="'testCases.form.links.picker.searchPlaceholder' | translate"
          [attr.aria-label]="'testCases.form.links.picker.searchAria' | translate"
          (input)="onSearch($event)"
        />
      </div>
      <select
        class="anf-auswahl__status"
        data-testid="tf-anf-auswahl-status"
        [class.anf-auswahl__status--aktiv]="statusFilter() !== ''"
        [disabled]="loading()"
        [attr.aria-label]="'testCases.form.links.picker.statusAria' | translate"
        (change)="onStatusChange($event)"
      >
        <option value="" [selected]="statusFilter() === ''">
          {{ 'testCases.form.links.picker.allStatus' | translate }}
        </option>
        @for (status of statuses(); track status) {
          <option [value]="status" [selected]="statusFilter() === status">{{ status | requirementStatusLabel }}</option>
        }
      </select>
    </div>

    <div class="anf-auswahl__inhalt">
      @if (loading()) {
        <p class="anf-auswahl__hinweis" role="status">
          {{ 'testCases.form.links.modal.requirementLoading' | translate }}
        </p>
      } @else if (loadError()) {
        <div class="anf-auswahl__fehler" role="alert">
          <p class="anf-auswahl__fehler-text">{{ 'testCases.form.links.modal.requirementLoadError' | translate }}</p>
          <button type="button" class="anf-auswahl__retry" data-testid="tc-link-requirement-retry" (click)="load()">
            {{ 'testCases.form.links.modal.requirementRetry' | translate }}
          </button>
        </div>
      } @else if (projectEmpty()) {
        <p class="anf-auswahl__hinweis">{{ 'testCases.form.links.modal.requirementEmpty' | translate }}</p>
      } @else if (allLinked()) {
        <p class="anf-auswahl__hinweis">{{ 'testCases.form.links.picker.allLinked' | translate }}</p>
      } @else if (rows().length === 0) {
        <p class="anf-auswahl__hinweis">{{ 'testCases.form.links.picker.noMatch' | translate }}</p>
      } @else {
        <div
          class="anf-auswahl__liste"
          role="listbox"
          tabindex="0"
          [attr.aria-label]="'testCases.form.links.picker.listAria' | translate"
          [attr.aria-activedescendant]="activeOptionId()"
          (keydown)="onListKeydown($event)"
        >
          @for (row of rows(); track row.requirement.id) {
            <!-- Tastatur läuft über die Liste (aria-activedescendant), nicht über die Option. -->
            <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
            <div
              class="anf-auswahl__option"
              data-testid="tf-anf-auswahl-option"
              role="option"
              [id]="optionId(row.requirement.key)"
              [class.anf-auswahl__option--markiert]="markedKey() === row.requirement.key"
              [attr.aria-selected]="markedKey() === row.requirement.key"
              (click)="mark(row.requirement)"
              (dblclick)="pick(row.requirement)"
            >
              <span class="anf-auswahl__radio" aria-hidden="true"></span>
              <code class="anf-auswahl__key">{{ row.requirement.key }}</code>
              <span class="anf-auswahl__text">
                <span class="anf-auswahl__titel">{{ row.requirement.title }}</span>
                <span class="anf-auswahl__meta">{{ row.meta }}</span>
              </span>
              <app-req-status-pill [kind]="row.statusKind" [label]="row.requirement.status | requirementStatusLabel" />
            </div>
          }
        </div>
      }
    </div>

    <div class="anf-auswahl__fuss">
      <span class="anf-auswahl__zaehler" aria-live="polite">
        {{ 'testCases.form.links.picker.count' | translate: { shown: rows().length, total: available().length } }}
      </span>
      <button type="button" class="anf-auswahl__abbrechen" (click)="close()">
        {{ 'testCases.form.links.picker.cancel' | translate }}
      </button>
      <button
        type="button"
        class="anf-auswahl__uebernehmen"
        data-testid="tf-anf-auswahl-uebernehmen"
        [disabled]="!markedRequirement()"
        (click)="pick()"
      >
        <mat-icon aria-hidden="true">check</mat-icon>
        {{ 'testCases.form.links.picker.pick' | translate }}
      </button>
    </div>
  </div>
</div>
